// types
import { type ModuleType as UserBackoffice } from "./_definitions"
import { type State } from "../../types"

export const userBackofficeSelector = (state: State): UserBackoffice => state.userBackoffice
